import { Injectable } from '@angular/core';

import { Action, State, StateContext, Store, NgxsOnInit } from '@ngxs/store';
import { Device, DeviceInfo } from '@capacitor/device';

import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { ToastService } from '../../core/services/toast.service';
import {
  ShowToastAction,
  ShowErrorToastAction,
  SetDeviceInfoAction,
} from './application.actions';


export interface ApplicationStateModel {
  deviceInfo: DeviceInfo;
}

@State<ApplicationStateModel>({
  name: 'application',
  defaults: {
    deviceInfo: null,
  },
})
@Injectable()
export class ApplicationState implements NgxsOnInit {

  constructor(
    private store: Store,
    private toastService: ToastService,
  ) {
  }

  ngxsOnInit(ctx: StateContext<ApplicationStateModel>) {
  }

  @Action(ShowToastAction)
  showToast(ctx: StateContext<ApplicationStateModel>, action: ShowToastAction) {
    this.toastService.showToast(action.message);
  }

  @Action(ShowErrorToastAction)
  showErrorToast(ctx: StateContext<ApplicationStateModel>, action: ShowErrorToastAction) {
    this.toastService.showErrorToast(action.message);
  }

  @Action(SetDeviceInfoAction)
  setDeviceInfo(ctx: StateContext<ApplicationStateModel>, action: SetDeviceInfoAction) {
    return from(Device.getInfo()).pipe(
      map(deviceInfo => {
        return ctx.patchState({
          deviceInfo,
        });
      }),
    );
  }

}
